import useUserState from "ui/adapter/state/useUserState";
import useGetUserInfo from "features/users/hooks/useGetUserInfo";
import changeUserRole from "ui/user/utils/changeUserRole";
import UserRoleSelect from "../UserRoleSelect/UserRoleSelect";
import type { RoleDto } from "common/models/api/models/RoleDto";
import { useNavigate } from "react-router-dom";
import { DEFAULT_MAIN_PAGE_BY_ROLE } from "../UserRoleSelectorForm/UserRoleSelectorForm.types";
import { useQueryClient } from "react-query";
import { Queries } from "ui/query/queries";

export interface AppRoleSelectProps {
    className?: string;
    style?: React.CSSProperties;
    onSelectRole?: (role: RoleDto) => void;
}

export default function AppRoleSelect(props: AppRoleSelectProps): JSX.Element {
    const queryClient = useQueryClient();
    const { selectedRole } = useUserState();
    const { data: { roles = [] } = {} } = useGetUserInfo();
    const shouldShowRoleSelect = roles.length > 1 && Boolean(selectedRole);
    const navigate = useNavigate();

    function handleOnRoleSelected(role: RoleDto) {
        resetQueries();
        changeUserRole(role);
        props.onSelectRole?.(role);
        const path = DEFAULT_MAIN_PAGE_BY_ROLE[role.roleType];
        if (path) {
            changeUserRole(role);
            navigate(path);
        }
    }

    function resetQueries() {
        queryClient.removeQueries({ queryKey: Queries.USER_KPIS });
        queryClient.removeQueries({ queryKey: Queries.SCHEDULED_MINT_FIND_ALL });
        queryClient.removeQueries({ queryKey: Queries.TRANSACTION_FIND_ALL });
    }

    return <>{shouldShowRoleSelect && <UserRoleSelect role={selectedRole} onRoleSelected={handleOnRoleSelected} {...props} />}</>; // skipcq: JS-0424
}
